import React from 'react'
import './Train.css'
import { Link } from 'react-router-dom'
import  Moon  from '../assets/moon.jpg'
import  Pod  from '../assets/pod.jpg'


const Train = () => {
  return (
    <div className='training'>
      <div className='left'>
        <h1>Training</h1>
        <p> Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.</p>
        <Link to='/contact'><button className='btn'>Contact</button></Link>
      </div>
      <div className='right'>
        <div className='img-container'>
          <div className='image-stack top'>
            <img src={Moon} className='img' alt='' />
          </div>
          <div className='image-stack bottom'>
            <img src={Pod} className='img' alt='' />
          </div>
        </div>
      </div>

    </div>
  )
}

export default Train